import { createEmptyLogsAndVars, dwReportError, recordVariable, } from "../../diagnostics/clientErrors";
const LOCALSTORAGE_KEY = "jwt";
const REFRESH_TOKEN_KEY = "refreshToken";
export const hasSavedJwt = () => {
    return localStorage.getItem(LOCALSTORAGE_KEY) !== null;
};
export const storeJwt = async (jwt) => {
    localStorage.setItem(LOCALSTORAGE_KEY, jwt);
};
export const loadJwt = async () => {
    const logsAndVars = createEmptyLogsAndVars("jwtStorage:loadJwt");
    try {
        const jwt = localStorage.getItem(LOCALSTORAGE_KEY);
        recordVariable(logsAndVars, "jwt from localStorage", jwt);
        return jwt;
    }
    catch (error) {
        dwReportError(null, undefined, error, { logsAndVars });
        return null;
    }
};
export const deleteJwt = async () => {
    localStorage.removeItem(LOCALSTORAGE_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
};
export const storeRefreshToken = (token) => {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
};
export const loadRefreshToken = () => {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
};
export const deleteRefreshToken = () => {
    localStorage.removeItem(REFRESH_TOKEN_KEY);
};
